var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 89.5,
    stroke: "#DFE0EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 81,
    fill: "#DFE0EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4231_5156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.125 94.6406C99.8591 94.6406 106.945 87.5544 106.945 78.8203C106.945 70.0862 99.8591 63 91.125 63C82.3909 63 75.3047 70.0862 75.3047 78.8203C75.3047 87.5544 82.3909 94.6406 91.125 94.6406ZM105.188 98.1562H99.134C96.6951 99.2769 93.9814 99.9141 91.125 99.9141C88.2686 99.9141 85.5659 99.2769 83.116 98.1562H77.0625C69.2952 98.1562 63 104.451 63 112.219V113.977C63 116.888 65.3621 119.25 68.2734 119.25H113.977C116.888 119.25 119.25 116.888 119.25 113.977V112.219C119.25 104.451 112.955 98.1562 105.188 98.1562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4231_5156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.25,
    height: 56.25,
    fill: "white",
    transform: "translate(63 63)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.09b6dec57966f6f0bed75fe9cc65d8ad.svg";
export { ForwardRef as ReactComponent };